import {DataTransferObject} from './DataTransferObject';
import {LocalStorageObject} from '../Utilities';
import {Model} from '../Models';

export class ShopUrlsDTO extends DataTransferObject implements LocalStorageObject {
  successUrl: string | null = null;
  failureUrl: string | null = null;
  cancelUrl: string | null = null;

  fromStorage(data: any) {
    return this.fromData(data);
  }

  /**
   * unused, actually no model, see fromData below
   * @deprecated
   * @param model
   */
  fromModel(model: Model): ShopUrlsDTO {
    return this.fromData(model);
  }

  fromData(data: any): ShopUrlsDTO {
    const dto = new ShopUrlsDTO();
    dto.successUrl = data.successUrl;
    dto.failureUrl = data.failureUrl;
    dto.cancelUrl = data.cancelUrl;
    return dto;
  }
}
